export const flexLayout2 = {
    name: 'layout2',
    cols: [
        {
            col: 0,
            flex: '25'
        },
        {
            col: 1,
            flex: '25'
        },
        {
            col: 2,
            flex: '50'
        }
    ],
    rows: [
        // {row: 0, class: 'row-class0'},
        // {row: 1, class: 'row-class1'},
        // {row: 2, class: 'row-class2'},
        {row: 3, class: 'row-class3'},
        {row: 4, class: 'row-class4'},
        {row: 5, class: 'row-class5'}
    ],
    fields: [
        {
            fieldName: 'label2',
            col: 0,
            row: 0,
            colspan: 2,
            layoutAlign: 'start start',
            flex: '100',
            class: 'margin-left-5',

        },
        {
            fieldName: 'text1',
            col: 0,
            row: 1,
            colspan: 2,
            flex: '100',
            maxCollapsedWidth: 0,
            class: 'super-deper'
        },
        {
            fieldName: 'text2',
            col: 0,
            row: 2,
            colspan: 2,
            flex: '100',
            maxCollapsedWidth: 0
        },
        {
            fieldName: 'text3',
            col: 0,
            row: 3,
            colspan: 2,
            flex: '100',
            maxCollapsedWidth: 0
        },
        // {
        //     fieldName: 'image3',
        //     col: 2,
        //     row: 0,
        //     rowspan: 4,
        //     class: 'grid-item-320'
        // },
        {
            fieldName: 'checkbox1',
            col: 0,
            row: 4,
            colspan: 3,
            layoutAlign: 'start center',
            class: 'margin-top-15'
        },
        {
            fieldName: 'button1',
            col: 0,
            row: 5,
            colspan: 3,
            layoutAlign: 'start center',
            class: 'margin-top-15'
        }
    ]
};
